export enum CMxApplication {
  DRAWER = 'DRAWER',
  AWAITING_RESOURCES = 'AWAITING_RESOURCES',
  DRAWER_CONTENT = 'DRAWER_CONTENT',
  LOADING = 'LOADING',
  IN_PROGRESS = 'IN_PROGRESS',
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  FEEDBACK = 'FEEDBACK',
  DISMISS_FEEDBACK = 'DISMISS_FEEDBACK',
  CHOOSE_CONTEXT = 'CHOOSE_CONTEXT'
}

export enum FeedbackLevel {
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export enum Case {
  IMPORT_TO_AMPLIFY = 'IMPORT_TO_AMPLIFY',
  ORGANIZATION_CONTEXT = 'ORGANIZATION_CONTEXT',
  DETAIL = 'CASE_DETAIL',
  DETAIL_WILL_NAVIGATE = 'DETAIL_WILL_NAVIGATE',
  DETAIL_TOGGLE_ARTIFACTS = 'DETAIL_TOGGLE_ARTIFACTS',
  BPM_TASKS = 'BPM_TASKS',
  FEATURE_SELECTION = 'CASE_FEATURE_SELECTION',
  FEATURE_ACTIVATION = 'CASE_FEATURE_ACTIVATION',
  CODE_DESCRIPTIONS = 'CODE_DESCRIPTIONS',
  INVOICE_CODE_DESCRIPTIONS = 'INVOICE_CODE_DESCRIPTIONS',
  DICTIONARY = 'CASE_DICTIONARY',
  LIST = 'LIST_CASES',
  SELECTED = 'CASE_SELECTED',
  FILTER = 'CASE_FILTER',
  DATE_FILTER = 'DATE_FILTER',
  CASE_STATUS = 'CASE_STATUS',
  BILLING_GROUP = 'BILLING_GROUP',
  SUBMITTER_ACCESSION_SEARCH = 'SUBMITTER_ACCESSION_SEARCH',
  BPM_EVIDENCE = 'BPM_EVIDENCE',
  TENANT = 'GET_TENANTS',
  CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS',
  APPLY_DEFAULT_FILTERS = 'APPLY_DEFAULT_FILTERS',
  TOGGLE_TIMELINE = 'TOGGLE_TIMELINE',
  DETAIL_INIT = 'CASE_DETAIL_INITIAL',
  LIST_INIT = 'CASE_LIST_INITIAL',
  SET_ACTIVE_PROCESS_ID = 'SET_ACTIVE_PROCESS_ID',
  CASE_AND_PROCESS_ID = 'CASE_AND_PROCESS_ID',
  LAUNCH_WORKITEM_IN_AMPLIFY = 'LAUNCH_WORKITEM_IN_AMPLIFY',
  GET_PREV_OR_NEXT_CASE = 'GET_PREV_OR_NEXT_CASE',
  SET_ACTIVE_NOTE = 'SET_ACTIVE_NOTE',
  SHOW_ORDER_NUMBER = 'SHOW_ORDER_NUMBER',
  IGNORE_EVIDENCE = 'IGNORE_EVIDENCE',
  FETCH_WORKITEM_DETAILS = 'FETCH_WORKITEM_DETAILS',
  UPDATE_WORKITEM_DISMISSED = 'UPDATE_WORKITEM_DISMISSED',
  FETCH_WORKER_FULLNAME = 'FETCH_WORKER_FULLNAME',
  FETCH_GROUP_NAME = 'FETCH_GROUP_NAME'
}

export enum UserInterface {
  BOOTSTRAP = 'BOOTSTRAP',
  REPLACE_UI_STATE = 'REPLACE_UI_STATE',
  LOGOUT = 'LOGOUT',
  NAVIGATE = 'NAVIGATE',
  DETAIL_TOGGLE_PHI = 'DETAIL_TOGGLE_PHI',
  SHOW_MODAL_MESSAGE = 'SHOW_MODAL_MESSAGE',
  DISMISS_MODAL_MESSAGE = 'DISMISS_MODAL_MESSAGE',
  ADMIN_TAB_CHANGE = 'ADMIN_TAB_CHANGE',
  SET_ACTIVE_USER = 'SET_ACTIVE_USER',
  OPEN_CHILD_WINDOW = 'OPEN_CHILD_WINDOW',
  NAVIGATE_CONTEXT = 'NAVIGATE_CONTEXT',
  SET_DEFAULT_HOMEPAGE = 'SET_DEFAULT_HOMEPAGE',
  SET_BACK_TO_WORKLIST_PATH = 'SET_BACK_TO_WORKLIST_PATH',
  MODAL_SUBMIT = 'MODAL_SUBMIT',
  REFRESH = 'REFRESH'
}

export enum UserSession {
  TIMEOUT = 'TIMEOUT',
  REFRESH = 'REFRESH',
  RESET = 'RESET',
  ACTIVITY_PROMPT = 'ACTIVITY_PROMPT'
}

export enum ParentWindow {
  PARENT_NAVIGATION = 'PARENT_NAVIGATION'
}

export enum AuthenticatedWindow {
  ACTIVITY = 'AUTHENTICATED_WINDOW_ACTIVITY',
  SHOULD_REFRESH = 'AUTHENTICATED_WINDOW_SHOULD_REFRESH'
}

export enum CaseJSON {
  LOAD = 'CASE_JSON_LOAD',
  SET_ACTIVE_PROCESS = 'SET_ACTIVE_PROCESS'
}

export enum Router {
  LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
}

export enum Eula {
  SAVE_EULA = 'SAVE_EULA',
  FETCH_EULA = 'FETCH_EULA',
  ACCEPT_EULA = 'ACCEPT_EULA',
  CANCEL_EULA = 'CANCEL_EULA',
  ACCEPT_INIT = 'ACCEPT_EULA_INITIAL'
}

export enum AmplifyAuthenticate {
  AUTHENTICATE = 'AUTHENTICATE',
  AUTOMATE = 'AUTOMATE',
  USER_DETAILS = 'USER_DETAILS'
}

export enum AmplifyUIActions {
  SHOW_CONFIRM = 'SHOW_CONFIRM',
  DISMISS_CONFIRM = 'DISMISS_CONFIRM',
  HANDLE_CONFIRM = 'HANDLE_CONFIRM',
  AMPLIFY_FEEDBACK = 'AMPLIFY_FEEDBACK',
  HIDE_FEEDBACK = 'HIDE_FEEDBACK',
  SHOW_SIZE_EXP_WARNING = 'SHOW_SIZE_EXP_WARNING',
  HIDE_SIZE_EXP_WARNING = 'HIDE_SIZE_EXP_WARNING',
  SET_STANDALONE_MODE = 'SET_STANDALONE_MODE',
  SET_AMPLIFY_VIEW = 'SET_AMPLIFY_VIEW',
  SET_AUTOMATE_VIEW = 'SET_AUTOMATE_VIEW',
  SAVE_SERVICE_LINE_CAPABILITY = 'SAVE_SERVICE_LINE_CAPABILITY',
  GET_CODER_CONFIG = 'GET_CODER_CONFIG'
}

export enum InvoiceEditor {
  REMOVE_PROVIDER = 'REMOVE_PROVIDER',
  REMOVE_REFERRING_PERFORMER = 'REMOVE_REFERRING_PERFORMER',
  ADD_PROVIDER = 'ADD_PROVIDER',
  ADD_REFERRING_PERFORMER = 'ADD_REFERRING_PERFORMER',
  CHOOSE_PROVIDER = 'CHOOSE_PROVIDER',
  SEARCH_PROVIDERS = 'SEARCH_PROVIDERS',
  BILLING_PROVIDER_RESULTS = 'BILLING_PROVIDER_RESULTS',
  PERFORMING_PROVIDER_RESULTS = 'PERFORMING_PROVIDER_RESULTS',
  CREATE_INVOICE = 'CREATE_INVOICE',
  INVOICE_OPTIONS = 'INVOICE_OPTIONS',
  REMOVE_TRANSACTION = 'REMOVE_TRANSACTION',
  BILLING_AREA_OPTIONS = 'BILLING_AREA_OPTIONS',
  REMOVE_PERFORMER = 'REMOVE_ADDITION_PERFORMER',
  ADD_PERFORMER = 'ADD_ADDITION_PERFORMER',
  CHOOSE_PERFORMER = 'CHOOSE_ADDITION_PERFORMER',
  CHOOSE_REFERRING_PERFORMER = 'CHOOSE_REFERRING_PERFORMER',
  SEARCH_PERFORMERS = 'SEARCH_ADDITION_PERFORMERS',
  CHANGE_DATE_PERFORMER = 'CHANGE_DATE_ADDITION_PERFORMER',
  FEE_SCHEDULE_CHANGE = 'FEE_SCHEDULE_CHANGE',
  DEPARTMENT_CHANGE = 'DEPARTMENT_CHANGE',
  CANCEL_INVOICE = 'CANCEL_INVOICE',
  SAVE_INVOICE = 'SAVE_INVOICE',
  SEARCH_PROVIDERS_DATAACCESS = 'SEARCH_PROVIDERS_DATAACCESS',
  SEARCH_PROVIDERS_XCALIBER = 'SEARCH_PROVIDERS_XCALIBER'
}

export enum Launch {
  XCALIBER_TOKEN = 'XCALIBER_TOKEN',
  EPIC_TOKEN = 'EPIC_TOKEN',
  EPIC_CLOSE_ACTIVITY = 'EPIC_CLOSE_ACTIVITY',
  LOAD_FROM_URL = 'LOAD_FROM_URL',
  PARENT_CASE = 'PARENT_CASE',
  CONTEXT_PARAMS = 'CONTEXT_PARAMS',
  PARAMS_AVAILABLE = 'PARAMS_AVAILABLE',
  NAVIGATE_DETAIL = 'NAVIGATE_DETAIL',
  NAVIGATE_PATIENT = 'NAVIGATE_PATIENT',
  NAVIGATE_PROVIDER = 'NAVIGATE_PROVIDER',
  NAVIGATE_CODER_COMMENTS = 'NAVIGATE_CODER_COMMENTS',
  CASE_DETAIL = 'CASE_DETAIL',
  CASE_DETAIL_WITH_REFRESH = 'CASE_DETAIL_WITH_REFRESH',
  CASE_SELECTED = 'CASE_SELECTED',
  CASE_SEARCH = 'CASE_SEARCH',
  LOAD_CASE_FROM_ID = 'LOAD_CASE_FROM_ID',
  LOAD_CASE_WITH_TOKEN = 'LOAD_CASE_WITH_TOKEN',
  BILLING_GROUP = 'BILLING_GROUP',
  CODE_DESCRIPTIONS = 'CODE_DESCRIPTIONS',
  CASE_LOOKUP_ERROR = 'CASE_LOOKUP_ERROR',
  NAVIGATE_PROVIDER_XCALIBER = 'NAVIGATE_PROVIDER_XCALIBER',
  NAVIGATE_PROVIDER_DATAACCESS = 'NAVIGATE_PROVIDER_DATAACCESS'
}

export enum EpicLaunchPoints {
  NO_CONTEXT = 'NoContext',
  CHARGE_ROUTER = 'ChargeRouter',
  CHARGE_REVIEW = 'ChargeReview',
  FOLLOW_UP = 'FollowUp',
  ERROR = 'Error',
  ERROR2 = 'Error2'
}

export enum InvoiceMetadata {
  ORGANIZATION_AVAILABLE = 'ORGANIZATION_AVAILABLE'
}

export enum ImprovementAction {
  ADD = 'IMPROVEMENT_ADD',
  UPDATE = 'IMPROVEMENT_UPDATE',
  REMOVE = 'IMPROVEMENT_REMOVE',
  SEARCH = 'IMPROVEMENT_SEARCH',
  GET = 'IMPROVEMENT_GET',
  FETCH_IMPROVEMENT_OPTIONS = 'FETCH_IMPROVEMENT_OPTIONS',
  ADD_PROVIDER = 'IMPROVEMENT_PROVIDER_ADD',
  UPDATE_PROVIDER = 'IMPROVEMENT_PROVIDER_UPDATE',
  REMOVE_PROVIDER = 'IMPROVEMENT_PROVIDER_REMOVE'
}

export enum MergeCases {
  SHOW_MERGE_CASES_MODAL = 'SHOW_MERGE_CASES_MODAL',
  HIDE_MERGE_CASES_MODAL = 'HIDE_MERGE_CASES_MODAL',
  FETCH_MERGEABLE_CASES = 'FETCH_MERGEABLE_CASES',
  GET_DOCUMENTS_AS_HTML = 'GET_DOCUMENTS_AS_HTML',
  SET_ACTIVE_CASE_RUN = 'SET_ACTIVE_CASE_RUN',
  TOGGLE_MERGEABLE_CASE_SELECTION = 'TOGGLE_MERGEABLE_CASE_SELECTION',
  FETCH_MERGE_CASES = 'FETCH_MERGE_CASES',
  LAUNCH_IN_AMPLIFY = 'LAUNCH_IN_AMPLIFY',
  SPLIT_CASE = 'SPLIT_CASE'
}

export enum CreateCase {
  NAVIGATE_CREATE_CASE = 'NAVIGATE_CREATE_CASE',
  SUBMIT_CREATE_CASE = 'SUBMIT_CREATE_CASE',
  FETCH_NOTES_SPECIALTY = 'FETCH_NOTES_SPECIALTY'
}
export enum AttachDocs {
  SHOW_ATTACH_DOCS_MODAL = 'SHOW_ATTACH_DOCS_MODAL',
  HIDE_ATTACH_DOCS_MODAL = 'HIDE_ATTACH_DOCS_MODAL',
  GET_DOCS_TO_ATTACH = 'GET_DOCS_TO_ATTACH',
  FETCH_SPECIALTY_DICTIONARY = 'FETCH_SPECIALTY_DICTIONARY',
  FETCH_NOTE_TYPE_DICTIONARY = 'FETCH_NOTE_TYPE_DICTIONARY',
  DOWNLOAD_DOCS = 'DOWNLOAD_DOCS'
}

export enum Bench {
  FEATURE_SELECTION = 'FEATURE_SELECTION',
  CODE_DESCRIPTIONS = 'CODE_DESCRIPTIONS',
  ACTIVITY = 'ACTIVITY',
  OPTIMISTIC_CHANGE = 'OPTIMISTIC_CHANGE',
  OPTIMISTIC_PRO_TECH_CHANGE = 'OPTIMISTIC_PRO_TECH_CHANGE',
  POPUP_NAVIGATE = 'POPUP_NAVIGATE',
  POPUP_CLOSE = 'POPUP_CLOSE',
  PROMPT_CLOSE = 'PROMPT_CLOSE',
  CODE_SEARCH = 'CODE_SEARCH',
  CODE_SEARCH_DROP = 'CODE_SEARCH_DROP',
  CLEAR_SEARCH = 'CLEAR_SEARCH',
  CODE_ADD = 'CODE_ADD',
  BULK_CODE_ADD = 'BULK_CODE_ADD',
  BUNDLED_CODES_ADD = 'BUNDLED_CODES_ADD',
  CREATE_TRANSACTION_AND_CODE_ADD = 'CREATE_TRANSACTION_AND_CODE_ADD',
  CODE_UPDATE = 'CODE_UPDATE',
  CODE_REMOVE = 'CODE_REMOVE',
  BULK_CODE_REMOVE = 'BULK_CODE_REMOVE',
  TIME_BASED_CODE_ADD = 'TIME_BASED_CODE_ADD',
  TIME_BASED_CODE_UPDATE = 'TIME_BASED_CODE_UPDATE',
  TRANSACTION_ORDER_CHANGE = 'TRANSACTION_ORDER_CHANGE',
  REMOVE_INVOICE = 'REMOVE_INVOICE',
  SELECT_INVOICE_TO_EDIT = 'SELECT_INVOICE_TO_EDIT',
  SELECT_INVOICE_TO_ADD = 'SELECT_INVOICE_TO_ADD',
  CANCEL_INVOICES_POPUP = 'CANCEL_INVOICES_POPUP',
  CANCEL_INVOICES_CONFIRM = 'CANCEL_INVOICES_CONFIRM',
  CANCEL_INVOICES_DISMISS = 'CANCEL_INVOICES_DISMISS',
  OPEN_ADD_CHARGE_MODAL = 'OPEN_ADD_CHARGE_MODAL',
  CLOSE_ADD_CHARGE_MODAL = 'CLOSE_ADD_CHARGE_MODAL',
  ADD_TRANSACTION = 'ADD_TRANSACTION',
  ADD_TRANSACTION_FAILED = 'ADD_TRANSACTION_FAILED',
  ADD_TRANSACTION_LOADING = 'ADD_TRANSACTION_LOADING',
  TXN_SHARED_CODE = 'TXN_SHARED_CODE',
  SHOW_SUBMITTED_FEEDBACK = 'SHOW_SUBMITTED_FEEDBACK',
  SHOW_LOADING_SUBMISSION = 'SHOW_LOADING_SUBMISSION',
  SHOW_LOADING_CANCELATION = 'SHOW_LOADING_CANCELATION',
  HIDE_LOADING_SUBMISSION = 'HIDE_LOADING_SUBMISSION',
  HIDE_SUBMITTED_FEEDBACK = 'HIDE_SUBMITTED_FEEDBACK',
  SHOW_CANCELED_MODAL = 'SHOW_CANCELED_MODAL',
  SUBMITTED_MODAL_TIMER = 'SUBMITTED_MODAL_TIMER',
  SHOW_SIZE_EXP_WARNING = 'SHOW_SIZE_EXP_WARNING',
  HIDE_SIZE_EXP_WARNING = 'HIDE_SIZE_EXP_WARNING',
  DELETE_SIZE_EXP_WARNING = 'DELETE_SIZE_EXP_WARNING',
  ENABLE_TECH_PRO = 'ENABLE_TECH_PRO',
  DISABLE_TECH_PRO = 'DISABLE_TECH_PRO',
  TOGGLE_TECH_PRO = 'TOGGLE_TECH_PRO',
  SET_LOADING_TECH_PRO = 'SET_LOADING_TECH_PRO',
  SHOW_CLAIMS_ISSUES_MODAL = 'SHOW_CLAIMS_ISSUES_MODAL',
  HIDE_CLAIMS_ISSUES_MODAL = 'HIDE_CLAIMS_ISSUES_MODAL',
  SET_CLAIMS_ISSUES = 'SET_CLAIMS_ISSUES',
  SHOW_HOLD_CASE_MODAL = 'SHOW_HOLD_CASE_MODAL',
  HIDE_HOLD_CASE_MODAL = 'HIDE_HOLD_CASE_MODAL',
  SHOW_CASE_COMMENT_MODAL = 'SHOW_CASE_COMMENT_MODAL',
  HIDE_CASE_COMMENT_MODAL = 'HIDE_CASE_COMMENT_MODAL',
  SHOW_EXCLUSION_CASE_MODAL = 'SHOW_EXCLUSION_CASE_MODAL',
  HIDE_EXCLUSION_CASE_MODAL = 'HIDE_EXCLUSION_CASE_MODAL',
  TOGGLE_LATE_CASE_CLEAR_MODAL = 'TOGGLE_LATE_CASE_CLEAR_MODAL',
  SHOW_SPLIT_CASE_MODAL = 'SHOW_SPLIT_CASE_MODAL',
  HIDE_SPLIT_CASE_MODAL = 'HIDE_SPLIT_CASE_MODAL',
  TOGGLE_CHARGEABLE_CASE = 'TOGGLE_CHARGEABLE_CASE',
  CLEAR_LATE_CASE_UPDATE = 'CLEAR_LATE_CASE_UPDATE',
  HOLD_CASE = 'HOLD_CASE',
  OFFHOLD_CASE = 'OFFHOLD_CASE',
  FETCH_HOLD_CASE = 'FETCH_HOLD_CASE',
  FETCH_CASE_VERSIONS = 'FETCH_CASE_VERSIONS',
  NAVIGATE = 'NAVIGATE',
  TOGGLE_SUBMIT_OLD_CASE_MODAL = 'TOGGLE_SUBMIT_OLD_CASE_MODAL',
  SHOW_SIDE_NAV_BAR = 'SHOW_SIDE_NAV_BAR',
  HIDE_SIDE_NAV_BAR = 'HIDE_SIDE_NAV_BAR',
  LOAD_NEXT_OR_PREVIOUS_CASE = 'LOAD_NEXT_OR_PREVIOUS_CASE',
  LOAD_WORKITEM_IN_AMPLIFY = 'LOAD_WORKITEM_IN_AMPLIFY',
  LOAD_CURSOR_API_CONTEXT = 'LOAD_CURSOR_API_CONTEXT',
  RESET_CURSOR_API_CONTEXT = 'RESET_CURSOR_API_CONTEXT',
  FETCH_CASE_INTERACTIONS = 'FETCH_CASE_INTERACTIONS',
  FETCH_CASE_INTERACTIONS_INFINITE = 'FETCH_CASE_INTERACTIONS_INFINITE',
  FETCH_FLAGS = 'FETCH_FLAGS',
  FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES = 'FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES',
  FETCH_CASES_WITH_ENCOUNTER = 'FETCH_CASES_WITH_ENCOUNTER',
  FETCH_CODES_WITH_ENCOUNTER = 'FETCH_CODES_WITH_ENCOUNTER',
  GET_RELATED_CODES = 'GET_RELATED_CODES',
  FETCH_RELATED_CODES = 'FETCH_RELATED_CODES',
  SET_FILTER_TYPES_PATIENT_TIMELINE = 'SET_FILTER_TYPES_PATIENT_TIMELINE',
  SET_FILTER_DATES_PATIENT_TIMELINE = 'SET_FILTER_DATES_PATIENT_TIMELINE',
  SET_FILTER_TYPES_PATIENT_TIMELINE_INFINITE = 'SET_FILTER_TYPES_PATIENT_TIMELINE_INFINITE',
  SET_FILTER_DATES_PATIENT_TIMELINE_INFINITE = 'SET_FILTER_DATES_PATIENT_TIMELINE_INFINITE',
  LOAD_ROLES = 'LOAD_ROLES',
  UPDATE_PROCESS_INSTANCE = 'UPDATE_PROCESS_INSTANCE',
  FETCH_MESSAGE_COUNTS = 'FETCH_MESSAGE_COUNTS',
  FETCH_MESSAGE_COUNTS_INFINITE = 'FETCH_MESSAGE_COUNTS_INFINITE',
  FETCH_NOTE_TYPES = 'FETCH_NOTE_TYPES',
  PROVIDER_ROLETYPE_CONFIGURATION = 'PROVIDER_ROLETYPE_CONFIGURATION',
  UPDATE_TRANSACTION = 'UPDATE_TRANSACTION',
  UPDATE_TRANSACTION_OPTIMISTICALLY = 'UPDATE_TRANSACTION_OPTIMISTICALLY',
  CREATE_TRANSACTION_OPTIMISTICALLY = 'CREATE_TRANSACTION_OPTIMISTICALLY',
  REPLACE_OPTIMISTIC_TRANSACTION = 'REPLACE_OPTIMISTIC_TRANSACTION',
  UPDATE_TRANSACTION_ORDER_OPTIMISTICALLY = 'UPDATE_TRANSACTION_ORDER_OPTIMISTICALLY',
  DOCUMENT_METADATA = 'DOCUMENT_METADATA',
  SET_ACTIVE_NOTE = 'SET_ACTIVE_NOTE',
  SET_ACTIVE_MINI_TAB = 'SET_ACTIVE_MINI_TAB',
  SET_ACTIVE_VERTICAL_MINI_TAB = 'SET_ACTIVE_VERTICAL_MINI_TAB',
  SET_UNRESOLVED_DOCUMENTS = 'SET_UNRESOLVED_DOCUMENTS',
  FETCH_ORDER_TYPE_STATUS = 'FETCH_ORDER_TYPE_STATUS',
  ADD_CODER_NOTE = 'ADD_CODER_NOTE',
  ADD_USER_ACTIVITY_COMMENT = 'ADD_USER_ACTIVITY_COMMENT',
  FETCH_CODER_NOTES = 'FETCH_CODER_NOTES',
  SET_CODER_NOTE = 'SET_CODER_NOTE',
  UPDATE_CODER_NOTE = 'UPDATE_CODER_NOTE',
  DELETE_CODER_NOTE = 'DELETE_CODER_NOTE',
  TOGGLE_NOTE_EDIT_MODE = 'TOGGLE_NOTE_EDIT_MODE',
  FETCH_RELATED_CASE_FILTER_DICTIONARIES = 'FETCH_RELATED_CASE_FILTER_DICTIONARIES',
  UPDATE_RELATED_CASE_FILTER_SELECTION = 'UPDATE_RELATED_CASE_FILTER_SELECTION',
  ACQUIRE_CASE_ACCESS = 'ACQUIRE_CASE_ACCESS',
  REFRESH_CASE_ACCESS_TIMER = 'REFRESH_CASE_ACCESS_TIMER',
  RELEASE_CASE_ACCESS = 'RELEASE_CASE_ACCESS',
  CASE_OPEN_SUCCESS = 'CASE_OPEN_SUCCESS',
  CASE_OPEN_FAILED = 'CASE_OPEN_FAILED',
  CASE_OPEN_CONFLICT = 'CASE_OPEN_CONFLICT',
  REFRESH_TIMER_SUCCESS = 'REFRESH_TIMER_SUCCESS',
  RESET_CASE_ACCESS = 'RESET_CASE_ACCESS',
  SET_BENCH_MODE = 'SET_BENCH_MODE',
  CASE_CLOSE_SUCCESS = 'CASE_CLOSE_SUCCESS',
  CASE_CLOSE_NOT_FOUND = 'CASE_CLOSE_NOT_FOUND',
  CASE_CLOSE_CONFLICT = 'CASE_CLOSE_CONFLICT',
  CASE_CLOSE_FAILED = 'CASE_CLOSE_FAILED',
  SET_LOCK_CASE_UID = 'SET_LOCK_CASE_UID',
  FETCH_FLAGS_XCALIBER = 'FETCH_FLAGS_XCALIBER',
  FETCH_FLAGS_DATAACCESS = 'FETCH_FLAGS_DATAACCESS',
  REFRESH_HOLD_SUBMISSION = 'REFRESH_HOLD_SUBMISSION'
}

export enum CaseEdits {
  UPDATE_VALUE = 'UPDATE_VALUE',
  SET_ACTIVE_FIELD = 'SET_ACTIVE_FIELD',
  UPDATE_CASE = 'UPDATE_CASE',
  LOAD_ALL_PATIENT_DETAIL_OPTIONS = 'LOAD_ALL_PATIENT_DETAIL_OPTIONS',
  LOAD_PATIENT_DETAIL_OPTIONS = 'LOAD_PATIENT_DETAIL_OPTIONS'
}

export enum StateReset {
  RESET_COMMON = 'RESET_COMMON'
}

export enum GradeBenchPanel {
  GRADE_UPDATE = 'GRADE_UPDATE',
  UPDATE_OR_ADD_ASSESSMENT = 'UPDATE_OR_ADD_ASSESSMENT',
  UPDATE_UNITS = 'UPDATE_UNITS',
  FETCH_RISK_CATEGORIES = 'FETCH_RISK_CATEGORIES',
  ADD_CODE = 'ADD_CQA_CODE',
  ADD_PROCEDURE_CODE = 'ADD_PROCEDURE_CQA_CODE',
  ADD_DIAGNOSIS_CODE = 'ADD_DIAGNOSIS_CQA_CODE',
  ADD_MODIFIER_CODE = 'ADD_MODIFIER_CQA_CODE',
  REMOVE_CODE = 'REMOVE_CODE',
  FETCH_QA_RULE = 'FETCH_QA_RULE',
  CODE_EVENT = 'HANDLE_CODE_EVENT',
  RESEQUENCE_CODE = 'RESEQUENCE_CODE',
  LOAD_CQA_WORK_ITEM_FROM_URL = 'LOAD_CQA_WORK_ITEM_FROM_URL',
  REFRESH_SPAN_COMPLETION = 'REFRESH_SPAN_COMPLETION',
  FETCH_CQA_WORKITEM_DOCUMENTS = 'FETCH_CQA_WORKITEM_DOCUMENTS',
  FETCH_CQA_CODE_DESCRIPTIONS = 'FETCH_CQA_CODE_DESCRIPTIONS',
  CREATE_CQA_TRANSACTION = 'CREATE_CQA_TRANSACTION',
  DELETE_CQA_TRANSACTION = 'DELETE_CQA_TRANSACTION',
  SUBMIT_CQA_WORKITEM = 'SUBMIT_CQA_WORKITEM',
  RESOLVE_CQA_WORKITEM = 'RESOLVE_CQA_WORKITEM',
  DELETE_CQA_CODE = 'DELETE_CQA_CODE',
  RETRIEVE_ASSOCIATED_WORKITEMS = 'RETRIEVE_ASSOCIATED_WORKITEMS',
  LOAD_ASSOCIATED_WORKITEM = 'LOAD_ASSOCIATED_WORKITEM',
  FETCH_WORKER_INFO_FOR_USER = 'FETCH_WORKER_INFO_FOR_USER',
  FETCH_GRADER_WORK_ITEM_ACTIVITY = 'FETCH_GRADER_WORK_ITEM_ACTIVITY',
  ADD_EMPTY_SPAN = 'ADD_EMPTY_SPAN',
  ATTACH_CODE_TO_SPAN = 'ATTACH_CODE_TO_SPAN',
  DETACH_CODE_FROM_SPAN = 'DETACH_CODE_FROM_SPAN',
  DELETE_SPAN = 'DELETE_SPAN',
  FETCH_RUBRIC_VERSION = 'FETCH_RUBRIC_VERSION',
  CLEAR_RUBRIC_VERSION = 'CLEAR_RUBRIC_VERSION',
  UPDATE_ATTRIBUTE = 'UPDATE_ATTRIBUTE',
  FETCH_ATTRIBUTES = 'FETCH_ATTRIBUTES',
  DELETE_ATTRIBUTE = 'DELETE_ATTRIBUTE',
  FETCH_ALL_ATTRIBUTES = 'FETCH_ALL_ATTRIBUTES',
  ADD_USER_ACTIVITY_COMMENT = 'ADD_USER_ACTIVITY_COMMENT',
  CLEAR_DOWNSTREAM_ATTRIBUTES = 'CLEAR_DOWNSTREAM_ATTRIBUTES',
  AWAIT_AUTOSAVES_IDLE = 'AWAIT_AUTOSAVES_IDLE'
}
